import React from 'react'

import './RecommendedTemplate.scss'

interface RecommendedTemplateProps {
  templateLink?: string
  templateName: string
}

export const RecommendedTemplate = ({ templateLink, templateName }: RecommendedTemplateProps) => {
  return (
    <div className='modern-chat__recommended-template__wrapper'>
      <p>
        Ich empfehle die Vorlage: <i>{templateName}</i>
        {!!templateLink && (
          <>
            . <a href={templateLink}>Jetzt ansehen, bearbeiten und senden</a>
          </>
        )}
      </p>
    </div>
  )
}
